import iconMap from '@/language/en/utils/iconMap';

export default {
  iconMap,
};
